import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {
  BioentityMetadataQuery_bioentity as BioentityOrInaccessibleInfo,
  BioentityMetadataQuery_bioentity_BasicFolderItemNode_sampleDefinitionLinks_SampleDefinitionLinkNode as SampleDefinitionLinkNode,
  BioentityMetadataQuery_bioentity_BasicFolderItemNode_sampleDefinitionLinks_SampleDefinitionLinkNode_sampleDefinition as SampleDefinitionOrInaccessibleInfoNode,
} from 'metadata/__generated/BioentityMetadataQuery';

// Allow other GQL queries with slightly different sampleDefinition fieldsets to be used with this function.
type PartialSampleDefinitionLinks = Omit<SampleDefinitionLinkNode, 'sampleDefinition'> & {
  sampleDefinition: Partial<SampleDefinitionOrInaccessibleInfoNode> | null;
};
type PartialBioentityOrInaccessibleInfo = Omit<
  Partial<BioentityOrInaccessibleInfo>,
  'sampleDefinitionLinks'
> & {sampleDefinitionLinks?: Array<PartialSampleDefinitionLinks> | null};

/**
 * Checks if the trial sample system fieldset is enabled for a given entity.
 *
 * Currently, only custom entities can serve as trial samples and only custom entities include the
 * `sampleDefinitionLinks` field via `TrialSampleItemInterface` in entity GraphQL query responses.
 * A custom entity is a trial sample only if its `sampleDefinitionLinks` field is not null.
 * (Enforced in `trial_sample_graphql_resolvers.SampleDefinitionLinkDataLoader`.)
 *
 * @param entityOrInaccessibleInfo The GraphQL node representing the entity or inaccessible info to evaluate.
 * @returns {boolean} True if the entity is a trial sample, false otherwise.
 */
export function isTrialSampleInterfaceEnabled(
  entityOrInaccessibleInfo: PartialBioentityOrInaccessibleInfo
): boolean {
  // eslint-disable-next-line benchlint/no-in-operator
  if (!isInaccessible(entityOrInaccessibleInfo) && 'sampleDefinitionLinks' in entityOrInaccessibleInfo) {
    return entityOrInaccessibleInfo.sampleDefinitionLinks != null;
  }
  return false;
}
